export default {
  name: 'menu1-1',
  data() {
    return {};
  }
};